import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles, Loader2 } from "lucide-react";

export const ProgressSummaryCard = () => {
  const [state, setState] = useState({ loading: true });
  useEffect(() => {
    api.get("/me/progress-summary")
      .then((r) => setState({ summary: r.data?.summary }))
      .catch(() => setState({ error: true }));
  }, []);
  if (!state.loading && !state.summary && !state.error) return null;
  return (
    <div className="card-surface p-5 sm:p-6 fade-up border-l-4 border-[#CCFF00]" data-testid="progress-summary-card">
      <div className="label-mono mb-2 inline-flex items-center gap-2"><Sparkles className="w-3.5 h-3.5 text-[#CCFF00]" /> YOUR RALLY LAB JOURNEY</div>
      {state.loading && <div className="text-sm text-[#A3A3A3] inline-flex items-center gap-2" data-testid="progress-summary-loading"><Loader2 className="w-4 h-4 animate-spin" /> Writing your progress report…</div>}
      {state.error && <div className="text-sm text-[#A3A3A3]" data-testid="progress-summary-error">Your progress report isn't available just now — check back shortly.</div>}
      {state.summary && <div className="text-sm text-[#E5E5E5] leading-relaxed whitespace-pre-line" data-testid="progress-summary-text">{state.summary}</div>}
    </div>
  );
};
